import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

// @highcharts
import ExportData from 'highcharts/modules/export-data';
import Exporting from 'highcharts/modules/exporting';
import Highcharts from 'highcharts';

// @atlaskit
import ArrowLeftIcon from '@atlaskit/icon/glyph/arrow-left';
import Button from '@atlaskit/button';

// @source
import { Report as APIs } from '../../../../../server';
import { Messages, CoverageSpinner, Fragment } from '../../../../components';
import convert from './convert';
import options from './options';
import * as Styled from '../../styled';

const initialState = {
  isLoading: true,
  message: false,
};

class Chart extends Component {
  constructor(props) {
    super(props);
    this.charts = [];
    this.state = initialState;
    this.unmount = false;
    this.interval = setTimeout(() => null, 1);
    this.errorHandle = this.errorHandle.bind(this);
  }

  componentWillMount() {
    if (!this.props.isMobile) {
      Exporting(Highcharts);
      ExportData(Highcharts);
    }

    APIs.trend({
      data: {
        columns: this.props.columns,
        query: this.props.query,
        top: this.props.type === 'live' ? 100 : 0,
        token: this.props.token,
      },
      success: (data) => {
        this.charts = convert(data);
        this.setStateUnmount({ isLoading: false });
        this.createCharts();
      },
      error: this.errorHandle,
    });
  }

  componentDidMount() {
    const { outerWidth } = window;
    const body = document.getElementsByTagName('body')[0];
    const chart = document.getElementById('chart-viewer');

    body.style.overflow = 'hidden';
    chart.style.position = outerWidth < 768 ? 'fixed' : 'absolute';
  }

  componentWillUnmount() {
    this.unmount = true;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = '';

    Highcharts.charts.forEach((chart) => {
      if (chart) { chart.destroy(); }
    });

    clearTimeout(this.interval);
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  createCharts() {
    const { type } = this.props;

    this.charts.forEach((item) => {
      Highcharts.chart(`trend-${item.title}`, options(item));
    });

    if (type === 'live') {
      this.fetchLivePoints();
    }
  }

  fetchLivePoints() {
    const time = moment().format('DD.MM.YYYY HH:mm:ss');
    this.interval = setTimeout(() => {
      APIs.trend({
        data: {
          columns: this.props.columns,
          query: `(RealDate > CONVERT(DATETIME, '${time}', 104))`,
          top: 0,
          token: this.props.token,
        },
        success: (data) => {
          const charts = Highcharts.charts.filter(chart => (chart));
          const state = convert(data);

          charts.forEach((chart, a) => {
            chart.series.forEach((item, b) => {
              const points = state[a].series[b].data;
              if (points.length) {
                points.forEach((point) => {
                  item.addPoint({
                    name: point.name,
                    x: point.x,
                    y: point.y,
                  });
                });
              }
            });
          });

          this.fetchLivePoints();
        },
        error: this.errorHandle,
      });
    }, 1000);
  }

  errorHandle(messages) {
    this.setStateUnmount({
      isLoading: '',
      message: (
        <Messages
          component="Modal"
          items={messages}
          onClose={() => this.setState({ message: false })}
        />
      ),
    });
  }

  render() {
    const isMobile = window.outerWidth < 768;
    const { onClose } = this.props;
    const { isLoading } = this.state;

    return (
      <Styled.ChartViewer id="chart-viewer">
        <Fragment render={isLoading}>
          <CoverageSpinner />
        </Fragment>
        <Fragment render={!isLoading}>
          {this.charts.map(item => (
            <Styled.Chart
              key={item.title}
              style={{ height: `${99 / this.charts.length}%` }}
            >
              <div id={`trend-${item.title}`} />
            </Styled.Chart>
          ))}
        </Fragment>
        <Fragment render={Boolean(onClose)}>
          <Styled.TurnBack>
            <Button
              onClick={onClose}
              iconBefore={<ArrowLeftIcon size="small" />}
            >
              {isMobile ? '' : 'Turn Back'}
            </Button>
          </Styled.TurnBack>
        </Fragment>
        {this.state.message}
      </Styled.ChartViewer>
    );
  }
}

Chart.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  isMobile: PropTypes.bool,
  onClose: PropTypes.func,
  query: PropTypes.string.isRequired,
  token: PropTypes.number,
  type: PropTypes.string.isRequired,
};

Chart.defaultProps = {
  isMobile: false,
  onClose: null,
  token: null,
};

export default Chart;
